// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3EAj3","colCheckbox":"styles_colCheckbox__VC_Gs"};